import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer,
  BarChart, Bar
} from 'recharts';
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const formatYmdToLabel = (ymd) => {
  const [y, m, d] = String(ymd || '').slice(0, 10).split('-').map(Number);
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return String(ymd || '');
  if (m < 1 || m > 12) return String(ymd || '');
  return `${MONTHS[m - 1]} ${d}`;
};

const Charts = ({ ordersByDay, avgBumpTime, itemsData }) => {
  const formattedOrders = ordersByDay.map(d => ({
    ...d,
    label: formatYmdToLabel(d.date)
  }));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Line Chart: Orders by Day */}
      <div className="bg-white p-4 shadow rounded-xl">
        <h3 className="text-md font-semibold mb-2 text-blue-700">Orders by Day</h3>
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={formattedOrders}>
            <XAxis dataKey="label" />
            <YAxis />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="total_orders"
              stroke="#2563EB" // Tailwind blue-600
              strokeWidth={2}
              dot={{ fill: '#2563EB' }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Bar Chart: Top Items by Count */}
      <div className="bg-white p-4 shadow rounded-xl">
        <h3 className="text-md font-semibold mb-2 text-blue-700">Top 5 Items by Count</h3>
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={itemsData.slice(0, 5)}>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="total_quantity" fill="#3B82F6" /> {/* Tailwind blue-500 */}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Charts;
